<template>
  <div>
    <div class="mb-2 pe-4">
      <div class="d-flex align-items-center">
        <div class="color-common">
          <h3 class="title-page mb-0 ps-3">
            Sales Channel : {{ branchSelect.branch_name }}
          </h3>
        </div>
      </div>
    </div>
    <div class="page-header align-items-start min-vh-100">
      <span class="mask bg-white"></span>
      <div class="container" v-if="isLoadDone">
        <div class="row">
          <div class="col-lg-12 col-md-12 col-12 mx-auto">
            <div class="mt-4">
              <div class="d-flex align-items-center waiting-time">
                <Multiselect
                  v-model="waitingTimeSelect"
                  :options="waitingTime"
                  placeholder="Select Waiting Time"
                  :canClear="false"
                  @change="changeWaitingTime"
                />
                <material-button
                  class="ms-3 btn btn-sm btn-background"
                  @click="stopOrdering()"
                  >{{
                    branchSelect.stop_ordering
                      ? "Start Ordering"
                      : "Stop Ordering"
                  }}</material-button
                >
                <!-- M986: sound alert when a new Pending order arrives -->
                <material-button
                  v-if="isManualFlow"
                  class="ms-3 btn btn-sm d-inline-flex align-items-center"
                  :class="audioEnabled ? 'btn-background' : 'btn-audio-off'"
                  :title="audioEnabled ? 'Sound alert is on' : 'Sound alert is off'"
                  @click="toggleAudio()"
                >
                  <i class="material-icons-round me-1 audio-icon">{{
                    audioEnabled ? "volume_up" : "volume_off"
                  }}</i>
                  {{ audioEnabled ? "Audio On" : "Play Audio" }}
                </material-button>
              </div>
            </div>
            <div class="mt-5">
              <div class="row d-flex justify-content-center">
                <ul id="general-tab" class="nav nav-tabs">
                  <!-- M986: stores not linked to POS accept / reject each order -->
                  <template v-if="isManualFlow">
                    <li class="nav-item nav-first">
                      <a
                        id="nav_item_10"
                        class="nav-link"
                        :class="{ active: type == MANUAL_TAB.PENDING }"
                        @click="changeTab(MANUAL_TAB.PENDING)"
                        >Pending</a
                      >
                      <div class="count-order" v-if="pendingCount > 0">
                        {{ pendingCount }}
                      </div>
                    </li>
                    <li class="nav-item">
                      <a
                        id="nav_item_11"
                        class="nav-link"
                        :class="{ active: type == MANUAL_TAB.ACCEPTED }"
                        @click="changeTab(MANUAL_TAB.ACCEPTED)"
                        >Accepted</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        id="nav_item_12"
                        class="nav-link"
                        :class="{ active: type == MANUAL_TAB.REJECTED }"
                        @click="changeTab(MANUAL_TAB.REJECTED)"
                        >Rejected</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        id="nav_item_13"
                        class="nav-link"
                        :class="{ active: type == MANUAL_TAB.CANCELLED }"
                        @click="changeTab(MANUAL_TAB.CANCELLED)"
                        >Cancelled</a
                      >
                    </li>
                  </template>
                  <template v-else>
                  <li class="nav-item nav-first">
                    <a
                      id="nav_item_1"
                      class="nav-link"
                      :class="{ active: type == 1 }"
                      @click="changeTab(1)"
                      >Preparing</a
                    >
                    <div
                      class="count-order"
                      v-if="type == 1 && orders.length > 0"
                    >
                      {{ orders.length }}
                    </div>
                  </li>
                  <li class="nav-item">
                    <a id="nav_item_2" class="nav-link" @click="changeTab(2)"
                      >Ready</a
                    >
                  </li>
                  <li class="nav-item">
                    <a id="nav_item_0" class="nav-link" @click="changeTab(0)"
                      >Pending</a
                    >
                  </li>
                  </template>
                </ul>
              </div>
              <div class="row mt-5">
                <div class="px-0 d-flex justify-content-end">
                  <input
                    class="nosubmit"
                    type="search"
                    v-model="searchKeyword"
                    id="keyword_search"
                    extraClass
                    name="keyword_search"
                    placeholder="Search ..."
                    @input="onChangesearchKeyword"
                  />
                </div>
                <div class="px-0 mt-4">
                  <div class="table-responsive p-0 custom-table">
                    <table class="table align-items-center mb-0">
                      <thead v-if="isManualFlow">
                        <tr>
                          <th class="text-center font-weight-bolder w-5"></th>
                          <th class="text-center font-weight-bolder">No.</th>
                          <th class="text-center font-weight-bolder">Order Time</th>
                          <th class="text-center font-weight-bolder">Time</th>
                          <th class="text-center font-weight-bolder">Total</th>
                          <th class="text-center font-weight-bolder">Type</th>
                          <th class="font-weight-bolder">Details</th>
                          <th class="font-weight-bolder">Driver Contact</th>
                          <th class="text-center font-weight-bolder w-10">
                            Action
                          </th>
                        </tr>
                      </thead>
                      <thead v-else>
                        <tr>
                          <th class="text-center font-weight-bolder w-5"></th>
                          <th class="text-center font-weight-bolder">
                            From
                          </th>
                          <th class="text-center font-weight-bolder">
                            Receipt No.
                          </th>
                          <th class="text-center font-weight-bolder">
                            Order Date Time
                          </th>
                          <th class="text-center font-weight-bolder">Total</th>
                          <th class="text-center font-weight-bolder w-10">
                            POS Status
                          </th>
                          <th class="text-center font-weight-bolder">
                            Grab Status
                          </th>
                          <th class="text-center font-weight-bolder w-10">
                            Action
                          </th>
                          <th class="text-center font-weight-bolder">
                            Buyer
                          </th>
                          <th class="text-center font-weight-bolder">Pickup Date Time</th>
                          <th class="text-center font-weight-bolder">Delivery Address</th>
                          <th class="text-center font-weight-bolder">Delivery Contact</th>
                        </tr>
                      </thead>
                      <tbody v-if="orders.length">
                        <tr
                          v-for="(order, index) in orders"
                          :key="index"
                          :id="'order-' + order.transaction_id"
                        >
                          <td>
                            <i
                              class="material-icons-round opacity-10 mt-1 show-order-info"
                              @click="orderDetail(order)"
                              >add</i
                            >
                          </td>
                          <!-- M986: manual accept flow (iMakan-style columns) -->
                          <template v-if="isManualFlow">
                          <td
                            class="text-center text-xss font-weight-bold cl-22"
                          >
                            {{ order.receipt_no }}
                            <div
                              v-if="order.customer_remark"
                              class="text-danger fw-normal"
                              style="font-size: 11px;"
                            >
                              {{ order.customer_remark }}
                            </div>
                          </td>
                          <!-- M1007: when the customer placed the order -->
                          <td class="text-center text-xss cl-22 text-nowrap">
                            {{ order.created_at_format }}
                          </td>
                          <td class="text-center text-xss cl-22">
                            <div class="font-weight-bold">
                              {{ orderTimeLabel(order) }}
                            </div>
                            <div v-if="slotLabel(order)" class="text-secondary">
                              {{ slotLabel(order) }}
                            </div>
                          </td>
                          <td class="text-center text-xss cl-22">
                            {{ order.payment_amount_format }}
                          </td>
                          <td class="text-center text-xss font-weight-bold cl-22">
                            {{ isDeliveryOrder(order) ? "DELIVERY" : "PICKUP" }}
                            <div
                              v-if="isDeliveryOrder(order) && distanceLabel(order)"
                              class="fw-normal"
                            >
                              ({{ distanceLabel(order) }})
                            </div>
                          </td>
                          <td class="text-xss cl-22 details-cell">
                            <div class="font-weight-bold">{{ customerName(order) }}</div>
                            <div>{{ customerPhone(order) }}</div>
                            <div v-if="isDeliveryOrder(order)">
                              {{ deliveryAddress(order) }}
                            </div>
                            <div
                              v-if="isDeliveryOrder(order) && order.delivery_contact_recipient_name"
                              class="text-secondary"
                            >
                              Recipient: {{ order.delivery_contact_recipient_name }}
                              {{ order.delivery_contact_recipient_phone ?? '' }}
                            </div>
                            <div
                              v-if="deliveryMethodLabel(order)"
                              class="font-weight-bold mt-1"
                            >
                              Delivery by {{ deliveryMethodLabel(order) }}
                            </div>
                            <div
                              v-if="type == MANUAL_TAB.REJECTED && refundLabel(order)"
                              class="font-weight-bold mt-1"
                              :class="order.refund_status == 'REFUNDED' ? 'refund-ok' : 'refund-bad'"
                            >
                              {{ refundLabel(order) }}
                            </div>
                            <div v-if="order.lalamove_status" class="mt-1">
                              <span
                                class="font-weight-bold"
                                :class="{ 'text-danger': isLalamoveUndelivered(order) }"
                                >Lalamove: {{ order.lalamove_status }}</span
                              >
                              <!-- M1007: Lalamove's own order id -->
                              <div v-if="order.lalamove_order_id">
                                Order ID: {{ order.lalamove_order_id }}
                              </div>
                              <div
                                v-if="order.lalamove_status == 'FAILED' && order.lalamove_error_message"
                                class="text-danger text-break"
                              >
                                {{ order.lalamove_error_message }}
                              </div>
                              <div
                                v-if="isLalamoveUndelivered(order)"
                                class="tag-a-custom"
                                @click="confirmLalamoveBookAgain(order)"
                              >
                                Book again
                              </div>
                              <div v-if="order.lalamove_share_link">
                                <a
                                  :href="order.lalamove_share_link"
                                  target="_blank"
                                  rel="noopener"
                                  class="tag-a-custom"
                                  >Track</a
                                >
                              </div>
                            </div>
                          </td>
                          <!-- M1007: the Lalamove driver, once one is assigned -->
                          <td class="text-xss cl-22">
                            <template v-if="order.lalamove_driver_name">
                              <div class="font-weight-bold">{{ order.lalamove_driver_name }}</div>
                              <div v-if="order.lalamove_driver_plate_number">
                                {{ order.lalamove_driver_plate_number }}
                              </div>
                              <div v-if="order.lalamove_driver_phone">
                                {{ order.lalamove_driver_phone }}
                              </div>
                            </template>
                            <span v-else class="text-secondary">-</span>
                          </td>
                          <td class="text-center text-xss cl-22">
                            <div
                              class="d-flex flex-wrap align-items-center justify-content-center gap-2"
                            >
                              <template
                                v-if="type == MANUAL_TAB.PENDING && order.merchant_accept_status == MANUAL_STATUS.PENDING"
                              >
                                <material-button
                                  class="btn-accept-order"
                                  size="sm"
                                  @click="startAcceptOrder(order)"
                                >
                                  Accept
                                </material-button>
                                <material-button
                                  class="btn-reject-order"
                                  size="sm"
                                  variant="outline"
                                  color="danger"
                                  @click="confirmRejectOrder(order)"
                                >
                                  Reject
                                </material-button>
                              </template>
                              <material-button
                                v-if="
                                  type == MANUAL_TAB.ACCEPTED &&
                                  order.pos_status_label != 'Ready'
                                "
                                class="btn-confirm-order"
                                title="Ready for collection"
                                @click="confirmManualReady(order)"
                              >
                                <i class="material-icons-round opacity-10 mt-1"
                                  >local_mall</i
                                >
                              </material-button>
                              <button
                                v-if="type == MANUAL_TAB.ACCEPTED && canRefundOrder(order)"
                                type="button"
                                class="btn-refund-action"
                                @click="openRefundModal(order)"
                                :title="order.allinpay_card ? 'Void card payment' : 'Refund'"
                              >
                                <i class="material-icons">undo</i>
                                <!-- Allinpay card orders are voided, never refunded here -->
                                <span>{{ order.allinpay_card ? 'Void' : 'Refund' }}</span>
                              </button>
                              <span
                                v-if="type == MANUAL_TAB.ACCEPTED && needsOatsRefund(order)"
                                class="text-xxs text-secondary ms-2"
                                title="Allinpay only voids a card payment on the day it was taken, before the terminal is settled. Refund it in Allinpay OATS or with Allinpay's manual refund form: part of it is allowed, within 30 to 180 days depending on the card, and the MID needs enough balance."
                              >Refund via Allinpay OATS</span>
                              <span
                                v-if="type == MANUAL_TAB.ACCEPTED && !order.refund_status && airwallexRefundNote(order)"
                                class="text-xxs ms-2"
                                :class="airwallexRefundNote(order).error ? 'text-danger' : 'text-secondary'"
                              >{{ airwallexRefundNote(order).text }}</span>
                              <button
                                type="button"
                                class="btn-print-order"
                                title="Print this order"
                                @click="printOrder(order)"
                              >
                                <i class="material-icons">print</i>
                                <span>Print</span>
                              </button>
                            </div>
                          </td>
                          </template>
                          <template v-else>
                          <td class="text-center text-xss cl-22">
                            <img
                              v-if="platformIcon(order)"
                              :src="platformIcon(order)"
                              :alt="platformTitle(order)"
                              :title="platformTitle(order)"
                              style="width: 38px; height: 38px; object-fit: contain;"
                            />
                            <span v-else>{{ order.platform_type_label || '' }}</span>
                          </td>
                          <td
                            class="text-center text-xss font-weight-bold cl-22"
                          >
                            {{ order.receipt_no }}
                            <div
                              v-if="order.customer_remark"
                              class="text-danger fw-normal"
                              style="font-size: 11px;"
                            >
                              {{ order.customer_remark }}
                            </div>
                          </td>
                          <td class="text-center text-xss cl-22">
                            {{ order.created_at_format }}
                          </td>
                          <td class="text-center text-xss cl-22">
                            {{ order.payment_amount_format }}
                          </td>
                          <td
                            class="text-center text-xss font-weight-bold"
                            :style="{
                              color:
                                order.pos_status_label_color + ' !important',
                            }"
                          >
                            <div>{{ order.pos_status_label }}</div>
                            <div
                              v-if="
                                order.pos_status_label == 'Failed' &&
                                order.message_error_from_megapos
                              "
                              style="
                                white-space: break-spaces;
                                overflow-wrap: break-word;
                                max-width: 300px;
                              "
                            >
                              {{ order.message_error_from_megapos }}
                            </div>
                          </td>
                          <td class="text-center text-xss font-weight-bold">
                            <span
                              v-if="order.grab_order_state"
                              :style="{ color: order.grab_order_state_color }"
                            >
                              {{ order.grab_order_state }}
                            </span>
                          </td>
                          <td class="text-center text-xss cl-22">
                            <div
                              class="d-flex align-items-center justify-content-center"
                            >
                              <div
                                class="tag-a-custom me-3"
                                v-if="
                                  ['Timeout', 'Failed'].includes(
                                    order.pos_status_label
                                  )
                                "
                                @click="confirmRetryOrder(order)"
                              >
                                Retry
                              </div>
                              <material-button
                                v-if="
                                  type == ORDER_STATUS.PREPARING &&
                                  (order.pos_status_label == 'Inserted' || order.update_order_status_without_pos)
                                "
                                class="btn-confirm-order"
                                @click="moveOrderToReady(order)"
                              >
                                <i class="material-icons-round opacity-10 mt-1"
                                  >local_mall</i
                                >
                              </material-button>
                              <button
                                v-if="canRefundOrder(order)"
                                type="button"
                                class="btn-refund-action ms-2"
                                @click="openRefundModal(order)"
                                :title="order.allinpay_card ? 'Void card payment' : 'Refund'"
                              >
                                <i class="material-icons">undo</i>
                                <!-- Allinpay card orders are voided, never refunded here -->
                                <span>{{ order.allinpay_card ? 'Void' : 'Refund' }}</span>
                              </button>
                              <span
                                v-if="needsOatsRefund(order)"
                                class="text-xxs text-secondary ms-2"
                                title="Allinpay only voids a card payment on the day it was taken, before the terminal is settled. Refund it in Allinpay OATS or with Allinpay's manual refund form: part of it is allowed, within 30 to 180 days depending on the card, and the MID needs enough balance."
                              >Refund via Allinpay OATS</span>
                              <span
                                v-if="!order.refund_status && airwallexRefundNote(order)"
                                class="text-xxs ms-2"
                                :class="airwallexRefundNote(order).error ? 'text-danger' : 'text-secondary'"
                              >{{ airwallexRefundNote(order).text }}</span>
                            </div>
                          </td>
                          <td class="text-center text-xss cl-22">
                            {{ order.pickup_contact_name ?? order.delivery_contact_buyer_name ?? order.member_name ?? '' }} <br />
                            {{ order.pickup_contact_phone ?? order.delivery_contact_buyer_phone ?? order.phone_number ?? '' }}
                          </td>
                          <td class="text-center text-xss cl-22">
                            {{ order.pickup_date_time_format ?? '' }}
                          </td>
                          <td class="text-center text-xss cl-22">
                            {{ order.delivery_contact_address_line_1 ?? '' }}  <br />
                            {{ order.delivery_contact_address_line_2 ?? '' }}  <br />
                            {{ order.delivery_contact_postal_code ?? '' }}
                          </td>
                          <td class="text-center text-xss cl-22">
                            {{ order.delivery_contact_recipient_name ?? '' }} <br />
                            {{ order.delivery_contact_recipient_phone ?? '' }}
                            <!-- M986: Lalamove driver booked for this delivery -->
                            <div v-if="order.lalamove_status" class="mt-2">
                              <span
                                class="font-weight-bold"
                                :class="{ 'text-danger': isLalamoveUndelivered(order) }"
                                >Lalamove: {{ order.lalamove_status }}</span
                              >
                              <div
                                v-if="order.lalamove_status == 'FAILED' && order.lalamove_error_message"
                                class="text-danger text-break"
                              >
                                {{ order.lalamove_error_message }}
                              </div>
                              <div
                                v-if="isLalamoveUndelivered(order)"
                                class="tag-a-custom"
                                @click="confirmLalamoveBookAgain(order)"
                              >
                                Book again
                              </div>
                              <div v-if="order.lalamove_driver_name">
                                {{ order.lalamove_driver_name }}
                                {{ order.lalamove_driver_plate_number ? '(' + order.lalamove_driver_plate_number + ')' : '' }}
                                <br />
                                {{ order.lalamove_driver_phone ?? '' }}
                              </div>
                              <a
                                v-if="order.lalamove_share_link"
                                :href="order.lalamove_share_link"
                                target="_blank"
                                rel="noopener"
                                class="tag-a-custom"
                                >Track</a
                              >
                            </div>
                          </td>
                          </template>
                        </tr>
                      </tbody>
                      <tbody v-else class="no-data">
                        <tr>
                          <td colspan="12" class="text-center">
                            Empty, no order.
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  <div v-if="isManualFlow" class="manual-flow-notes mt-3">
                    <div>
                      *ASAP orders: the rider arrives about 30 mins after you
                      accept.
                    </div>
                    <div>
                      *Scheduled orders: the rider is booked for the delivery
                      time shown, or 30 mins after you accept if that is later
                      (Lalamove stores only).
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="position-fixed top-1 end-1 z-index-2 message-success" style="z-index: 99999 !important;">
    <material-snackbar
      v-if="snackbar === 'danger' || snackbar === 'success'"
      title
      date
      :description="message"
      :icon="{ component: 'campaign', color: 'white' }"
      :color="snackbar"
      :close-handler="closeSnackbar"
    />
  </div>
  <material-loading :active="loaderActive" />
  <ModalConfirm :message="messageConfirm" :process-yes="processYes" />
  <!-- M986: how a delivery order goes out once the store accepts it -->
  <div>
    <button
      style="display: none"
      type="button"
      class="btn-open-accept-modal"
      data-bs-toggle="modal"
      data-bs-target="#modalAcceptDeliveryOrder"
    ></button>
    <div
      class="modal fade"
      id="modalAcceptDeliveryOrder"
      tabindex="-1"
      aria-labelledby="modalAcceptDeliveryOrderLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalAcceptDeliveryOrderLabel">
              Accept order {{ acceptOrderSelect.receipt_no }}
            </h5>
            <button
              type="button"
              class="btn-close btn-close-accept-modal"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div class="modal-body">
            <p class="mb-3 cl-22">How will this order be delivered?</p>
            <div class="row g-3">
              <div
                class="col-12 col-md-4"
                v-for="option in deliveryOptions"
                :key="option.value"
              >
                <!-- M993: picks the vehicle; the Accept button below sends it. -->
                <button
                  type="button"
                  class="delivery-option w-100 h-100"
                  :class="{ selected: acceptDeliveryMethod === option.value }"
                  :aria-pressed="acceptDeliveryMethod === option.value"
                  @click="acceptDeliveryMethod = option.value"
                >
                  <i
                    v-if="acceptDeliveryMethod === option.value"
                    class="material-icons-round delivery-option-check"
                    >check_circle</i
                  >
                  <i class="material-icons-round">{{ option.icon }}</i>
                  <span class="delivery-option-title">{{ option.title }}</span>
                  <!-- M1005: Lalamove's own price for this order, not the fee the customer paid. -->
                  <span
                    v-if="lalamoveQuotes[option.value]"
                    class="delivery-option-price"
                    :class="{ 'is-muted': !lalamoveQuotes[option.value].total }"
                    :title="lalamoveQuotes[option.value].error || ''"
                  >
                    <template v-if="lalamoveQuotes[option.value].loading">Getting price…</template>
                    <template v-else-if="lalamoveQuotes[option.value].total">
                      {{ formatQuote(lalamoveQuotes[option.value]) }}
                      <small>est.</small>
                    </template>
                    <template v-else>Price unavailable</template>
                  </span>
                  <span class="delivery-option-sub">{{ option.sub }}</span>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-footer justify-content-center">
            <material-button
              class="btn-cancel-accept"
              size="sm"
              variant="outline"
              color="secondary"
              data-bs-dismiss="modal"
            >
              Cancel
            </material-button>
            <material-button
              class="btn-accept-order"
              size="sm"
              :disabled="!acceptDeliveryMethod"
              @click="acceptOrder(acceptOrderSelect, acceptDeliveryMethod)"
            >
              Accept
            </material-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <RefundModal
    ref="refundModal"
    :merchant-code="merchantCode"
    @refunded="onRefunded"
    @error="onRefundError"
  />
  <div>
    <button
      style="display: none"
      type="button"
      id="action-group-stock"
      data-bs-toggle="modal"
      data-bs-target="#modalCheckOrderPasscodePage"
    ></button>
    <div
      class="modal fade"
      id="modalCheckOrderPasscodePage"
      tabindex="-1"
      aria-hidden="true"
      data-bs-backdrop="static"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">PASSCODE REQUIRED</h5>
          </div>
          <div class="modal-body">
            <div class="form-group">
              <label class="control-label" style="margin-left: 0px"
                ><strong> Please enter passcode to continue.</strong></label
              >
              <div>
                <material-input
                  v-model="passcodeOrderValue"
                  extraClass="ml-5"
                  placeholder="Enter passcode"
                />
                <span class="is-invalid mt-1" v-if="passcodeIncorrect">{{
                  passcodeIncorrect
                }}</span>
              </div>
            </div>
          </div>
          <!-- Modal content-->
          <div class="modal-footer justify-content-center">
            <button
              style="display: none"
              type="button"
              class="btn btn-primary btn-close-modal btn-sm"
              data-bs-dismiss="modal"
            ></button>
            <button
              type="button"
              class="btn btn-success btn-background btn-sm"
              @click="checkPasscode"
            >
              Click Here to Start
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MaterialSnackbar from "@/components/MaterialSnackbar.vue";
import MaterialLoading from "@/components/MaterialLoading.vue";
import MaterialButton from "@/components/MaterialButton.vue";
import SettingStoreService from "../../services/settingStore.service";
import StockAccessService from "../../services/stock-access.service";
import Multiselect from "@vueform/multiselect";
import ModalConfirm from "@/components/ModalConfirm.vue";
import TokenService from "../../services/token.service";
import "bootstrap/dist/js/bootstrap.bundle";
import MaterialInput from "@/components/MaterialInput.vue";
import $ from "jquery";
import BoardRealtime from "../../services/board-realtime";
import posIcon from "@/assets/img/platform_type_icons/pos-icon.gif";
import qrIcon from "@/assets/img/platform_type_icons/qr-icon.png";
import kioskIcon from "@/assets/img/platform_type_icons/kiosk-icon.webp";
import grabIcon from "@/assets/img/platform_type_icons/grab-icon.png";
import lalamoveIcon from "@/assets/img/platform_type_icons/delivery-bike-icon.png";
import RefundModal from "@/views/members/components/RefundModal.vue";
import { canRefundAirwallex, airwallexRefundNote } from "@/views/members/components/airwallexRefund";
import moment from "moment";


// With a live socket the timer is no longer how this screen learns about orders
// — but it can never stop. This endpoint runs behind stock.passcode, and the
// request is what slides the passcode's hour forward.
const POLL_INTERVAL_MS = 15000;
const HEARTBEAT_INTERVAL_MS = 300000;

// One POS push moves several orders; each would otherwise cost a full re-read.
const COALESCE_MS = 400;

// connection.ready fires on every reconnect, so a websocket-server restart would
// have every screen in every outlet re-read at the same instant.
// Twenty seconds, not five: an Apache or websocket restart drops every board in
// every outlet at once, and their catch-up reads land on the same 80 php-fpm
// workers as the customer screens reconnecting beside them. Only that catch-up
// read waits; a board.updated after the reconnect is read at once.
const RESYNC_JITTER_MS = 20000;

// M986: tabs and order states of stores not linked to POS (manual accept flow).
const MANUAL_TAB = { PENDING: 10, ACCEPTED: 11, REJECTED: 12, CANCELLED: 13 };
const MANUAL_STATUS = { PENDING: 0, ACCEPTED: 1, REJECTED: 2 };
const DELIVERY_METHOD_LABEL = { 1: "MOTORCYCLE", 2: "CAR", 3: "OWN DELIVERY" };
// M993: sales channel Lalamove Vehicle (service_type) => Accept popup delivery_method.
const LALAMOVE_SERVICE_DELIVERY_METHOD = { MOTORCYCLE: 1, CAR: 2, OWN: 3 };
const AUDIO_STORAGE_KEY = "ORDER_MANAGEMENT_PLAY_AUDIO";
// M1002: the alert repeats on this beat while any order waits in Pending.
const ALERT_REPEAT_MS = 3000;

function readAudioSetting() {
  try {
    // M1002: on by default - only a merchant who switched it off stays off.
    return localStorage.getItem(AUDIO_STORAGE_KEY) !== "0";
  } catch (e) {
    return true;
  }
}

function saveAudioSetting(enabled) {
  try {
    localStorage.setItem(AUDIO_STORAGE_KEY, enabled ? "1" : "0");
  } catch (e) {
    // Storage blocked: the setting still holds until the page reloads.
  }
}

function escapeHtml(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}

export default {
  name: "create-menu",
  components: {
    MaterialSnackbar,
    MaterialLoading,
    MaterialButton,
    Multiselect,
    ModalConfirm,
    MaterialInput,
    RefundModal,
  },
  data() {
    return {
      isLoadDone: false,
      snackbar: null,
      message: "",
      loaderActive: false,
      platformTypeIcons: {
        1: posIcon,
        2: qrIcon,
        3: kioskIcon,
        4: grabIcon,
      },
      type: 1,
      branchSelect: {},
      branchCode: "",
      pollIntervalMs: null,
      realtime: null,
      realtimeConnected: false,
      refreshTimer: null,
      // When the armed refreshTimer fires, so a sooner request can replace it.
      refreshDueAt: 0,
      // A signal landed while a read was in flight and still owes us one more.
      refreshPending: false,
      // getOrderByBranch has no guard of its own, and this path is no longer
      // reached only by a 15s timer: a socket signal can arrive at any moment.
      // Two overlapping reads can finish out of order and render stale rows.
      isRefreshingList: false,
      // Bumped per list request. The guard above only covers the poll path; a
      // tab switch or search reads straight away, so the answer that lands last
      // is not necessarily the one asked for last.
      listSeq: 0,
      isDestroyed: false,
      merchantId: 0,
      orders: [],
      waitingTime: [],
      waitingTimeSelect: 0,
      interval: null,
      // Random first delay before interval starts (see armPollTimer).
      pollPhaseTimer: null,
      searchKeyword: "",
      searchTimerId: null,
      messageConfirm: "",
      orderSelect: {},
      // M986: which action the shared ModalConfirm's Yes runs ("lalamove" or null).
      confirmAction: null,
      orderInfo: {},
      token: TokenService.getLocalAccessToken(),
      passcodeOrderValue: "",
      passcodeIncorrect: "",
      ORDER_STATUS: {
        PREPARING: 1,
        READY: 2,
        PENDING: 0,
      },
      merchantCode: localStorage.getItem("MERCHANT_CODE") || "",
      MANUAL_TAB,
      MANUAL_STATUS,
      // M986: Pending count from the API (null = the API sent none).
      apiPendingCount: null,
      acceptOrderSelect: {},
      // M993: vehicle picked in the Accept popup; opens on the sales channel's Lalamove Vehicle.
      acceptDeliveryMethod: null,
      lalamoveServiceType: null,
      // M1005: { delivery_method: {loading} | {total, currency} | {error} } for the open popup.
      lalamoveQuotes: {},
      quoteRequestSeq: 0,
      deliveryOptions: [
        { value: 1, icon: "two_wheeler", title: "Motorcycle", sub: "Lalamove" },
        { value: 2, icon: "directions_car", title: "Car", sub: "Lalamove" },
        { value: 3, icon: "storefront", title: "Own delivery", sub: "Store's own rider" },
      ],
      audioEnabled: readAudioSetting(),
      audioContext: null,
      alertLoopTimer: null,
      // Pending ids / count seen on the last read, to tell a new order apart.
      seenPendingIds: null,
      lastPendingCount: null,
    };
  },
  computed: {
    // M986: stores not linked to POS (update_order_status_without_pos) accept
    // or reject every order by hand. POS-linked stores keep the old screen.
    isManualFlow() {
      return Number(this.branchSelect?.update_order_status_without_pos ?? 0) === 1;
    },
    pendingCount() {
      if (this.apiPendingCount !== null) return this.apiPendingCount;
      return this.type == MANUAL_TAB.PENDING && Array.isArray(this.orders)
        ? this.orders.length
        : 0;
    },
    // M1002: ring until every Pending order is accepted / rejected, or audio is off.
    shouldRingPending() {
      return this.isManualFlow && this.audioEnabled && this.pendingCount > 0;
    },
  },
  watch: {
    shouldRingPending(ring) {
      if (!ring) this.stopAlertLoop();
      else if (!this.alertLoopTimer) this.startAlertLoop();
    },
  },
  created() {
    this.branchCode = this.$route.params.branch_code ?? "";
    this.merchantId = this.$route.params.merchant_id ?? 0;
  },
  mounted() {
    // A passcode token from earlier in the hour is as good as a login here, so
    // a reload inside that hour does not re-prompt. Either way the fetch below
    // recovers if the API turns it down - a merchant token may have expired.
    if (this.token || StockAccessService.get(this.merchantId, this.branchCode)) {
      this.getOrderByBranch(true);
    } else {
      this.passcodeIncorrect = "";
      SettingStoreService.checkStockPasscodeExists({
        merchantId: this.merchantId,
        branchCode: this.branchCode,
      }).then(
        (response) => {
          const hasPasscode =
            response.data &&
            response.data.result &&
            response.data.result.isSuccess &&
            response.data.data &&
            response.data.data.has_passcode == 1;

          if (hasPasscode) {
            $("#action-group-stock").click();
          } else {
            this.getOrderByBranch(true);
          }
        },
        () => {
          $("#action-group-stock").click();
        }
      );
    }
    this.armPollTimer();
    this.startRealtime();

    // Browsers keep audio locked until the page gets a click.
    if (this.audioEnabled) {
      document.addEventListener("click", this.unlockAudio);
    }
  },
  unmounted() {
    this.isDestroyed = true;
    clearTimeout(this.pollPhaseTimer);
    this.pollPhaseTimer = null;
    clearInterval(this.interval);
    this.interval = null;
    clearTimeout(this.refreshTimer);
    this.refreshTimer = null;

    if (this.realtime) {
      this.realtime.stop();
      this.realtime = null;
    }

    this.stopAlertLoop();
    document.removeEventListener("click", this.unlockAudio);
    if (this.audioContext) {
      this.audioContext.close().catch(() => {});
      this.audioContext = null;
    }
  },
  methods: {
    // trailing: false is for the timer tick — it names no particular change, so
    // a read already running is exactly what it would have asked for.
    async onPollTick({ trailing = true } = {}) {
      if (!this.isLoadDone) return;

      if (this.isRefreshingList) {
        if (trailing) this.refreshPending = true;
        return;
      }

      this.isRefreshingList = true;
      this.refreshPending = false;

      try {
        $(".order-detail").remove();
        $(".show-order-info").html("add");
        await this.getOrderByBranch(false, true);
      } finally {
        this.isRefreshingList = false;
      }

      // A signal landed mid-read. The read above cannot be trusted to include
      // it, so spend exactly one more.
      if (this.refreshPending && !this.isDestroyed) {
        this.refreshPending = false;
        this.requestListRefresh();
      }
    },

    // This screen is scoped to one branch; the board room covers the physical
    // branch above it. The API resolves one to the other, so the screen hears a
    // few changes from sibling branches and re-reads its own list — never the
    // reverse, so it cannot miss one.
    boardTokenScope() {
      return this.branchCode
        ? { merchant_id: this.merchantId, branch_code: this.branchCode }
        : null;
    },


    /**
     * Arm the fallback timer at the rate the socket's state calls for.
     *
     * Never null, at any rate. This endpoint runs behind stock.passcode, and the
     * request is what slides the passcode's hour forward — a screen that stopped
     * calling it would lock while someone was using it.
     */
    armPollTimer() {
      if (this.isDestroyed) return;

      const wanted = this.realtimeConnected
        ? HEARTBEAT_INTERVAL_MS
        : POLL_INTERVAL_MS;

      if ((this.interval || this.pollPhaseTimer) && this.pollIntervalMs === wanted) {
        return;
      }

      clearTimeout(this.pollPhaseTimer);
      clearInterval(this.interval);
      this.interval = null;
      this.pollIntervalMs = wanted;

      // A socket restart re-arms every screen in the same second. Starting the
      // interval at a random point in its period keeps them from polling in
      // lockstep from then on.
      this.pollPhaseTimer = setTimeout(() => {
        this.pollPhaseTimer = null;
        this.interval = setInterval(
          () => this.onPollTick({ trailing: false }),
          wanted
        );
      }, Math.random() * wanted);
    },

    /**
     * Coalesce every reason to re-read into one request.
     *
     * One POS push moves several orders at once, so a burst is the normal case.
     */
    requestListRefresh(delayMs = COALESCE_MS) {
      if (this.isDestroyed) return;

      // An armed timer covers this request unless it fires later than asked —
      // a real change must not wait behind a reconnect's random resync delay.
      if (this.refreshTimer) {
        if (Date.now() + delayMs >= this.refreshDueAt) return;
        clearTimeout(this.refreshTimer);
      }

      this.refreshDueAt = Date.now() + delayMs;
      this.refreshTimer = setTimeout(() => {
        this.refreshTimer = null;
        this.onPollTick();
      }, delayMs);
    },

    // Realtime is best effort. If the token call fails or the socket never
    // connects, the screen keeps polling at the old rate and nothing above this
    // needs to know.
    async startRealtime() {
      if (this.isDestroyed || this.realtime) return;

      const scope = this.boardTokenScope();

      if (!scope) return;

      this.realtime = new BoardRealtime({
        fetchToken: async () => {
          const response = await SettingStoreService.getWsTokenForBoard(scope);
          const result = response.data.result;

          return result && result.isSuccess ? response.data.data : null;
        },
        onSignal: (signal) => {
          this.requestListRefresh(
            signal && signal.resync ? Math.random() * RESYNC_JITTER_MS : COALESCE_MS
          );
        },
        onConnectionChange: (connected) => {
          this.realtimeConnected = connected;
          this.armPollTimer();
        },
      });

      // Read back rather than kept from `new`: data() hands out a reactive
      // proxy, and the identity check below has to compare like with like.
      const realtime = this.realtime;

      // A false start leaves no socket behind, but a non-null this.realtime
      // would still block every later attempt. Behind a passcode that is the
      // normal first answer — the token endpoint says no until the passcode is
      // in — so clear it and let the first successful list load try again.
      if (!(await realtime.start()) && this.realtime === realtime) {
        realtime.stop();
        this.realtime = null;
      }
    },

    changeTab(type) {
      this.searchKeyword = "";
      this.orders = {};
      this.type = type;
      $("#general-tab .nav-link").removeClass("active");
      $("#nav_item_" + type).addClass("active");
      this.getOrderByBranch();
    },

    checkPasscode() {
      this.passcodeIncorrect = "";
      this.isLoadData = false;
      var dataForm = {
        merchant_id: this.merchantId,
        branch_code: this.branchCode,
        passcode: this.passcodeOrderValue,
      };

      SettingStoreService.checkPasscodeOrderPage(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            // The token is what the order writes on this public link carry.
            StockAccessService.save(
              this.merchantId,
              this.branchCode,
              response.data.data
            );
            this.passcodeIncorrect = "";
            this.getOrderByBranch(true);
            $(".btn-close-modal").click();
          } else {
            this.passcodeIncorrect = response.data.result.message;
          }
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error;
          this.setTimeOutNotification();
        }
      );
    },

    changeWaitingTime(waitingTime) {
      if (this.branchCode) {
        this.showLoader();
        var dataForm = {
          merchant_id: this.merchantId,
          branch_code: this.branchCode,
          waiting_time: waitingTime,
        };

        SettingStoreService.changeWaitingTime(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.snackbar = "success";
              this.message = "Change success";
              this.setTimeOutNotification();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error;
            this.setTimeOutNotification();
            this.hideLoader();
          }
        );
      }
    },

    getOrderByBranch(isFirstLoad = false, isSilent = false) {
      if (this.branchCode) {
        // isSilent is for the background refresh. A full-screen loader on every
        // auto-refresh was tolerable at one flash per 15s; once a socket signal
        // can trigger the same read, it would flash at moments nothing on screen
        // explains. Every existing caller omits it and keeps the loader.
        if (!isSilent) {
          this.showLoader();
        }
        var dataForm = {
          merchant_id: this.merchantId,
          branch_code: this.branchCode,
          type: this.type,
          search_keyword: this.searchKeyword,
        };
        const seq = ++this.listSeq;

        // Returned so the caller can tell when the read is over. Existing
        // callers ignore it, exactly as before.
        return SettingStoreService.getOrderByBranch(dataForm).then(
          (response) => {
            // A newer read is out (tab switch, search, signal): its rows win,
            // and its answer clears the loader, whichever lands first. The
            // branch-level parts below still apply - nothing else sets them.
            const isLatest = seq === this.listSeq;

            if (response.data.result.isSuccess) {
              this.branchSelect = response.data.data.branch;
              this.lalamoveServiceType = response.data.data.lalamove_service_type ?? null;
              if (isLatest) this.orders = response.data.data.orders;

              // M986: a manual-flow store opens on its own Pending tab.
              if (
                this.isManualFlow &&
                !Object.values(MANUAL_TAB).includes(Number(this.type))
              ) {
                this.type = MANUAL_TAB.PENDING;
                this.orders = [];
                this.seenPendingIds = null;
                this.lastPendingCount = null;
                if (isFirstLoad) {
                  this.waitingTime = response.data.data.waiting_time;
                  this.waitingTimeSelect = this.branchSelect.waiting_time;
                  this.isLoadDone = true;
                  this.startRealtime();
                }
                if (isLatest) this.hideLoader();
                return this.getOrderByBranch();
              }

              if (this.isManualFlow) {
                this.trackPendingOrders(response.data.data, isLatest && isSilent);
              }

              if (isFirstLoad) {
                this.waitingTime = response.data.data.waiting_time;
                this.waitingTimeSelect = this.branchSelect.waiting_time;
                this.isLoadDone = true;

                // The read just got past stock.passcode, so the board token
                // will too. A no-op when realtime is already running.
                this.startRealtime();
              }
            } else if (response.data.data?.errorCode === "PASSCODE_REQUIRED") {
              // A merchant token that has since expired gets us this far; the
              // passcode is the way back in rather than a dead end.
              StockAccessService.clear(this.merchantId, this.branchCode);
              $("#action-group-stock").click();
            } else if (isLatest) {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            if (isLatest) this.hideLoader();
          },
          (error) => {
            if (seq !== this.listSeq) return;

            this.snackbar = "danger";
            this.message = error;
            this.setTimeOutNotification();
            this.hideLoader();
          }
        );
      }

      return Promise.resolve();
    },

    onChangesearchKeyword(event) {
      this.searchKeyword = event.target.value;
      clearTimeout(this.searchTimerId);
      this.searchTimerId = setTimeout(() => {
        this.getOrderByBranch();
      }, 1000);
    },

    processYes() {
      // M986: the page has one ModalConfirm, so "Book again" routes on a flag.
      if (this.confirmAction === "lalamove") {
        this.lalamoveBookAgain();
        return;
      }
      if (this.confirmAction === "reject") {
        this.rejectOrder();
        return;
      }
      if (this.confirmAction === "ready") {
        this.confirmAction = null;
        this.handleMoveOrder();
        return;
      }
      if (this.orderSelect) {
        if (this.orderSelect.pos_status_label == "Inserted" || this.orderSelect.update_order_status_without_pos) {
          this.handleMoveOrder();
        } else {
          this.retryOrder();
        }
      }
    },

    confirmRetryOrder(order) {
      this.confirmAction = null;
      this.messageConfirm = "Are you sure you want to retry this order?";
      $(".btn-confirm-modal").click();
      this.orderSelect = order;
    },

    // M986: a Lalamove booking that ended without a delivery.
    isLalamoveUndelivered(order) {
      return ["FAILED", "REJECTED", "CANCELED", "EXPIRED"].includes(order.lalamove_status);
    },

    confirmLalamoveBookAgain(order) {
      this.confirmAction = "lalamove";
      this.orderSelect = order;
      this.messageConfirm =
        "Book a Lalamove driver again for order " + order.receipt_no + "?";
      $(".btn-confirm-modal").click();
    },

    lalamoveBookAgain() {
      $(".btn-close-modal").click();
      this.confirmAction = null;
      this.showLoader();

      SettingStoreService.lalamoveBookAgain({
        merchant_id: this.merchantId,
        branch_code: this.branchCode,
        transaction_id: this.orderSelect.transaction_id,
      }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "Booking a Lalamove driver again - status updates within a minute";
            this.getOrderByBranch();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
          }
          this.setTimeOutNotification();
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = error.response?.data?.result?.message ?? error.message;
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },

    // ---- M986: manual accept flow -------------------------------------------

    trackPendingOrders(data, isPoll) {
      const rawCount = data?.pending_count ?? data?.counts?.[MANUAL_TAB.PENDING];
      const count =
        rawCount === undefined || rawCount === null ? null : Number(rawCount);
      let hasNew = false;

      this.apiPendingCount = count;

      if (count !== null) {
        if (isPoll && this.lastPendingCount !== null && count > this.lastPendingCount) {
          hasNew = true;
        }
        this.lastPendingCount = count;
      }

      // A search narrows the list, so it says nothing about what is new.
      if (
        this.type == MANUAL_TAB.PENDING &&
        !this.searchKeyword &&
        Array.isArray(data?.orders)
      ) {
        const ids = data.orders.map((order) => order.transaction_id);

        if (
          isPoll &&
          this.seenPendingIds &&
          ids.some((id) => !this.seenPendingIds.includes(id))
        ) {
          hasNew = true;
        }
        this.seenPendingIds = ids;
      }

      // M1002: Audio off only silences the orders already waiting - a new one turns it back on.
      if (hasNew && !this.audioEnabled) {
        this.audioEnabled = true;
        saveAudioSetting(true);
      }

      // Ring now and restart the beat, so the loop's next beep does not overlap.
      if (hasNew && this.shouldRingPending) this.startAlertLoop();
      else if (hasNew) this.playAlert();
    },

    // M1006: a delivery that goes out by a Lalamove driver - picked in the Accept
    // popup (Motorcycle / Car), or booked on payment for a POS-linked store.
    isLalamoveOrder(order) {
      return (
        [LALAMOVE_SERVICE_DELIVERY_METHOD.MOTORCYCLE, LALAMOVE_SERVICE_DELIVERY_METHOD.CAR].includes(
          Number(order.delivery_method)
        ) || Boolean(order.lalamove_status)
      );
    },

    platformIcon(order) {
      return this.isLalamoveOrder(order) ? lalamoveIcon : this.platformTypeIcons[order.platform_type];
    },

    platformTitle(order) {
      return this.isLalamoveOrder(order) ? "Lalamove Delivery" : order.platform_type_label || "";
    },

    isDeliveryOrder(order) {
      return Boolean(
        order.delivery_method ||
          order.delivery_contact_address_line_1 ||
          order.delivery_contact_postal_code ||
          order.delivery_contact_recipient_name
      );
    },

    // "TODAY, 18:00" / "Wed, 07/10 11:15" from the delivery or pickup slot;
    // the order time when the order has no slot.
    orderTimeLabel(order) {
      let date = null;
      let time = null;

      if (order.delivery_date && order.delivery_time) {
        date = order.delivery_date;
        time = order.delivery_time;
      } else if (order.pickup_date && order.pickup_time) {
        date = order.pickup_date;
        time = order.pickup_time;
      }

      if (!date) return order.created_at_format ?? "";

      const slot = moment(
        String(date).slice(0, 10) + " " + String(time).slice(0, 5),
        "YYYY-MM-DD HH:mm",
        true
      );

      if (!slot.isValid()) return order.created_at_format ?? "";

      return slot.isSame(moment(), "day")
        ? "TODAY, " + slot.format("HH:mm")
        : slot.format("ddd, DD/MM HH:mm");
    },

    slotLabel(order) {
      return order.delivery_slot_display ?? order.slot_display ?? "";
    },

    distanceLabel(order) {
      if (order.distance_km === null || order.distance_km === undefined || order.distance_km === "") {
        return "";
      }
      const km = Number(order.distance_km);
      return Number.isFinite(km) ? km.toFixed(2) + " km" : "";
    },

    customerName(order) {
      return order.pickup_contact_name ?? order.delivery_contact_buyer_name ?? order.member_name ?? "";
    },

    customerPhone(order) {
      return order.pickup_contact_phone ?? order.delivery_contact_buyer_phone ?? order.phone_number ?? "";
    },

    deliveryAddress(order) {
      return [
        order.delivery_contact_address_line_1,
        order.delivery_contact_address_line_2,
        order.delivery_contact_postal_code,
      ]
        .filter((part) => part)
        .join(", ");
    },

    deliveryMethodLabel(order) {
      if (!this.isDeliveryOrder(order)) return "";
      return DELIVERY_METHOD_LABEL[order.delivery_method] ?? "";
    },

    refundLabel(order) {
      switch (order.refund_status) {
        case "REFUNDED":
          return "Refunded";
        // PROCESSING: Airwallex refund sent, waiting for Airwallex to confirm it.
        case "PENDING":
        case "PROCESSING":
          return "Refund in progress";
        case "FAILED":
          return "Refund failed" + (order.refund_error ? ": " + order.refund_error : "");
        case "MANUAL":
          return "Refund manually";
        default:
          return "";
      }
    },

    apiErrorMessage(error) {
      return error?.response?.data?.result?.message ?? error?.message ?? "An error has occurred";
    },

    startAcceptOrder(order) {
      if (this.isDeliveryOrder(order)) {
        this.acceptOrderSelect = order;
        // M993: no matching card (Van, Lalamove off) - the merchant must pick one.
        this.acceptDeliveryMethod = LALAMOVE_SERVICE_DELIVERY_METHOD[this.lalamoveServiceType] ?? null;
        this.getLalamoveQuotes(order);
        $(".btn-open-accept-modal").click();
        return;
      }
      // Pickup: nothing to choose.
      this.acceptOrder(order, null);
    },

    // M1005: price Motorcycle and Car with Lalamove while the popup is open.
    // An estimate only - the driver is booked on a fresh quotation after Accept.
    getLalamoveQuotes(order) {
      const seq = ++this.quoteRequestSeq;
      if (!this.lalamoveServiceType || this.lalamoveServiceType === "OWN") {
        this.lalamoveQuotes = {};
        return;
      }
      this.lalamoveQuotes = { 1: { loading: true }, 2: { loading: true } };

      const dataForm = {
        merchant_id: this.merchantId,
        branch_code: this.branchCode,
        transaction_id: order.transaction_id,
      };
      const failAll = (message) => {
        const error = { error: message || "Lalamove price is unavailable" };
        this.lalamoveQuotes = { 1: error, 2: error };
      };
      SettingStoreService.getLalamoveQuote(dataForm).then(
        (response) => {
          // The popup moved on to another order (or was reopened) meanwhile.
          if (seq !== this.quoteRequestSeq) return;
          if (response.data.result.isSuccess) {
            const quotes = response.data.data.quotes || {};
            this.lalamoveQuotes = {
              1: quotes[1] || { error: "Lalamove price is unavailable" },
              2: quotes[2] || { error: "Lalamove price is unavailable" },
            };
          } else {
            failAll(response.data.result.message);
          }
        },
        () => {
          if (seq === this.quoteRequestSeq) failAll();
        }
      );
    },

    formatQuote(quote) {
      const amount = Number(quote.total).toFixed(2);
      return quote.currency === "SGD" ? "S$" + amount : (quote.currency + " " + amount).trim();
    },

    acceptOrder(order, deliveryMethod) {
      $(".btn-close-accept-modal").click();
      this.showLoader();

      const dataForm = {
        merchant_id: this.merchantId,
        branch_code: this.branchCode,
        transaction_id: order.transaction_id,
      };
      if (deliveryMethod) dataForm.delivery_method = deliveryMethod;

      SettingStoreService.acceptOrder(dataForm).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message =
              deliveryMethod === 1 || deliveryMethod === 2
                ? "Order " + order.receipt_no + " accepted - booking a Lalamove driver"
                : "Order " + order.receipt_no + " accepted";
            this.acceptOrderSelect = {};
            this.getOrderByBranch();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
          }
          this.setTimeOutNotification();
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = this.apiErrorMessage(error);
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },

    confirmRejectOrder(order) {
      this.confirmAction = "reject";
      this.orderSelect = order;
      this.messageConfirm =
        "Reject order " + order.receipt_no + "? The customer's payment will be refunded.";
      $(".btn-confirm-modal").click();
    },

    rejectOrder() {
      $(".btn-close-modal").click();
      this.confirmAction = null;
      this.showLoader();
      const order = this.orderSelect;

      SettingStoreService.rejectOrder({
        merchant_id: this.merchantId,
        branch_code: this.branchCode,
        transaction_id: order.transaction_id,
      }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            const refund = this.refundLabel({
              refund_status: response.data.data?.refund_status,
              refund_error: response.data.data?.refund_error,
            });
            this.snackbar =
              ["FAILED", "MANUAL"].includes(response.data.data?.refund_status)
                ? "danger"
                : "success";
            this.message =
              "Order " + order.receipt_no + " rejected" + (refund ? " - " + refund : "");
            this.getOrderByBranch();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
          }
          this.setTimeOutNotification();
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
          this.message = this.apiErrorMessage(error);
          this.setTimeOutNotification();
          this.hideLoader();
        }
      );
    },

    confirmManualReady(order) {
      this.confirmAction = "ready";
      this.orderSelect = order;
      this.messageConfirm =
        "Confirm to change the status for order " +
        order.receipt_no +
        " to ready for collection?";
      $(".btn-confirm-modal").click();
    },

    // Prints this one order: its header plus the item lines the expand (+)
    // row shows, in a window of its own.
    printOrder(order) {
      // Opened inside the click; a window opened after the request would be
      // blocked as a popup.
      const printWindow = window.open("", "_blank", "width=420,height=640");

      if (!printWindow) {
        this.snackbar = "danger";
        this.message = "Allow pop-ups for this site to print the order";
        this.setTimeOutNotification();
        return;
      }
      printWindow.document.write("<p style='font-family:sans-serif'>Loading...</p>");

      SettingStoreService.orderDetail({
        merchant_id: this.merchantId,
        branch_code: this.branchCode,
        transaction_id: order.transaction_id,
      }).then(
        (response) => {
          if (!response.data.result.isSuccess) {
            printWindow.close();
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
            return;
          }
          this.writePrintWindow(printWindow, order, response.data.data);
        },
        (error) => {
          printWindow.close();
          this.snackbar = "danger";
          this.message = this.apiErrorMessage(error);
          this.setTimeOutNotification();
        }
      );
    },

    // M1007: "TestDriver (**438890*) +6522211222" for the printout.
    driverContact(order) {
      if (!order.lalamove_driver_name) return "";
      return [
        order.lalamove_driver_name,
        order.lalamove_driver_plate_number ? "(" + order.lalamove_driver_plate_number + ")" : "",
        order.lalamove_driver_phone ?? "",
      ]
        .filter((v) => v)
        .join(" ");
    },

    writePrintWindow(printWindow, order, detailHtml) {
      // The API answers with a <tr><td>…</td></tr>; keep the cell's content.
      const parsed = new DOMParser().parseFromString(
        "<table>" + (detailHtml || "") + "</table>",
        "text/html"
      );
      const cell = parsed.querySelector("td");
      const itemsHtml = cell ? cell.innerHTML : "";
      const isDelivery = this.isDeliveryOrder(order);
      const distance = this.distanceLabel(order);
      const method = this.deliveryMethodLabel(order);
      const row = (label, value) =>
        value
          ? "<tr><th>" + escapeHtml(label) + "</th><td>" + escapeHtml(value) + "</td></tr>"
          : "";

      const html =
        "<!doctype html><html><head><meta charset='utf-8'><title>Order " +
        escapeHtml(order.receipt_no) +
        "</title><style>" +
        "body{font-family:Arial,sans-serif;font-size:13px;color:#222;margin:16px}" +
        "h2{font-size:18px;margin:0 0 4px}" +
        ".sub{color:#555;margin-bottom:12px}" +
        "table{border-collapse:collapse;width:100%;margin-bottom:12px}" +
        "th{text-align:left;padding:3px 8px 3px 0;vertical-align:top;white-space:nowrap;width:30%}" +
        "td{padding:3px 0;vertical-align:top}" +
        ".items{border-top:1px dashed #999;padding-top:8px}" +
        ".item-info{display:flex;gap:8px;margin-bottom:6px}" +
        ".item-info .no{min-width:18px}" +
        ".font-weight-bold{font-weight:bold}" +
        ".print-bar{display:flex;justify-content:flex-end;margin-bottom:12px}" +
        ".print-bar button{font:inherit;font-weight:bold;padding:6px 16px;border:1px solid #344767;border-radius:6px;background:#344767;color:#fff;cursor:pointer}" +
        "@media print{.print-bar{display:none}}" +
        "</style></head><body>" +
        "<div class='print-bar'><button type='button' onclick='window.print()'>Print</button></div>" +
        "<h2>Order " + escapeHtml(order.receipt_no) + "</h2>" +
        "<div class='sub'>" + escapeHtml(this.branchSelect.branch_name ?? "") + "</div>" +
        "<table>" +
        row("Time", this.orderTimeLabel(order)) +
        row("Slot", this.slotLabel(order)) +
        row("Type", (isDelivery ? "DELIVERY" : "PICKUP") + (isDelivery && distance ? " (" + distance + ")" : "")) +
        row("Name", this.customerName(order)) +
        row("Phone", this.customerPhone(order)) +
        (isDelivery ? row("Address", this.deliveryAddress(order)) : "") +
        (isDelivery ? row("Recipient", [order.delivery_contact_recipient_name, order.delivery_contact_recipient_phone].filter((v) => v).join(" ")) : "") +
        (method ? row("Delivery by", method) : "") +
        row("Lalamove ID", order.lalamove_order_id) +
        row("Driver", this.driverContact(order)) +
        row("Remark", order.customer_remark) +
        row("Total", order.payment_amount_format) +
        row("Ordered at", order.created_at_format) +
        "</table>" +
        "<div class='items'>" + itemsHtml + "</div>" +
        "</body></html>";

      printWindow.document.open();
      printWindow.document.write(html);
      printWindow.document.close();
      // A preview: the merchant prints from its own Print button, and
      // cancelling the print dialog leaves the preview open.
      printWindow.focus();
    },

    toggleAudio() {
      this.audioEnabled = !this.audioEnabled;
      saveAudioSetting(this.audioEnabled);

      if (this.audioEnabled) {
        // This click is the user gesture that lets the page play sound.
        this.unlockAudio();
        if (!this.shouldRingPending) this.playAlert();
      } else {
        document.removeEventListener("click", this.unlockAudio);
      }
    },

    getAudioContext() {
      if (!this.audioContext) {
        const AudioContextClass = window.AudioContext || window.webkitAudioContext;
        if (!AudioContextClass) return null;
        this.audioContext = new AudioContextClass();
      }
      return this.audioContext;
    },

    unlockAudio() {
      document.removeEventListener("click", this.unlockAudio);
      try {
        const context = this.getAudioContext();
        if (context && context.state === "suspended") {
          context.resume().catch(() => {});
        }
      } catch (e) {
        // No Web Audio in this browser: the alert stays silent.
      }
    },

    startAlertLoop() {
      this.stopAlertLoop();
      if (this.isDestroyed) return;
      this.playAlert();
      this.alertLoopTimer = setInterval(() => this.playAlert(), ALERT_REPEAT_MS);
    },

    stopAlertLoop() {
      clearInterval(this.alertLoopTimer);
      this.alertLoopTimer = null;
    },

    // Three short beeps.
    playAlert() {
      if (!this.audioEnabled) return;
      try {
        const context = this.getAudioContext();
        if (!context) return;
        if (context.state === "suspended") context.resume().catch(() => {});

        const start = context.currentTime + 0.05;
        for (let i = 0; i < 3; i++) {
          const at = start + i * 0.3;
          const oscillator = context.createOscillator();
          const gain = context.createGain();
          oscillator.type = "sine";
          oscillator.frequency.setValueAtTime(880, at);
          gain.gain.setValueAtTime(0.0001, at);
          gain.gain.exponentialRampToValueAtTime(0.4, at + 0.02);
          gain.gain.exponentialRampToValueAtTime(0.0001, at + 0.2);
          oscillator.connect(gain);
          gain.connect(context.destination);
          oscillator.start(at);
          oscillator.stop(at + 0.22);
        }
      } catch (e) {
        // Audio is a convenience; never let it break the list.
      }
    },

    retryOrder() {
      $(".btn-close-modal").click();
      this.showLoader();

      var dataForm = {
        merchant_id: this.merchantId,
        branch_code: this.branchCode,
        transaction_id: this.orderSelect.transaction_id,
      };

      SettingStoreService.retryOrder(dataForm).then(
        async (response) => {
          if (response.data.result.isSuccess) {
            this.snackbar = "success";
            this.message = "Order retry successfully";
            this.setTimeOutNotification();
            this.getOrderByBranch();
          } else {
            this.snackbar = "danger";
            this.message = response.data.result.message;
            this.setTimeOutNotification();
          }
          this.hideLoader();
        },
        (error) => {
          this.snackbar = "danger";
            this.message = error.response.data.result.message;
            this.hideLoader();
          this.hideLoader();
        }
      );
    },

    canRefundOrder(order) {
      if (!order || !order.transaction_id) return false;
      // Airwallex, or a kiosk order paid by card on its Allinpay terminal.
      if (!order.airwallex_order_id && !order.allinpay_card) return false;
      // Airwallex: the BE works out what is still refundable (RefundSummary);
      // an API without those fields yet keeps the check below.
      if (!order.allinpay_card && order.airwallex_refundable !== undefined) return canRefundAirwallex(order);
      // Allinpay: a refund still being confirmed is checked from the modal.
      if (order.allinpay_refund_pending) return true;
      // Allinpay: a card payment is voided only today, before the terminal
      // is settled (BE flag); past that it is refunded in OATS.
      if (order.allinpay_card && !order.allinpay_voidable) return false;
      const paid = Number(order.payment_amount || 0);
      const refunded = Number(order.total_refund_amount || 0);
      return paid > 0 && refunded < paid;
    },
    // Allinpay card payment past its void window, not given back yet.
    needsOatsRefund(order) {
      if (!order || !order.allinpay_card || order.allinpay_voidable || order.allinpay_refund_pending) return false;
      return Number(order.total_refund_amount || 0) < Number(order.payment_amount || 0);
    },
    airwallexRefundNote,
    openRefundModal(order) {
      this.$refs.refundModal.open(order);
    },
    onRefunded(event) {
      this.snackbar = "success";
      this.message = event?.message || "Refund successful";
      this.setTimeOutNotification();
      $(".order-detail").remove();
      $(".show-order-info").html("add");
      this.getOrderByBranch();
    },
    onRefundError(message) {
      this.snackbar = "danger";
      this.message = message || "Refund failed";
      this.setTimeOutNotification();
    },

    moveOrderToReady(order) {
      this.confirmAction = null;
      this.orderSelect = order;
      this.messageConfirm =
        "Confirm to change the status for order " +
        order.receipt_no +
        " to ready for collection?";
      $(".btn-confirm-modal").click();
    },

    handleMoveOrder() {
      this.showLoader();
      $(".btn-close-modal").click();

      if (this.orderSelect && this.orderSelect.transaction_id) {
        var dataForm = {
          merchant_id: this.merchantId,
          branch_code: this.branchCode,
          transaction_id: this.orderSelect.transaction_id,
        };

        SettingStoreService.moveOrder(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              this.orderSelect = {};
              this.snackbar = "success";
              this.message = "Move successfully";
              this.setTimeOutNotification();
              this.getOrderByBranch();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error.response.data.result.message;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
      }
    },

    orderDetail(order) {
      var orderDetailElement = $(".order-detail.order-" + order.transaction_id);

      if (orderDetailElement.length) {
        orderDetailElement.remove();
        $("#order-" + order.transaction_id + " i.show-order-info").html("add");
      } else {
        this.showLoader();
        var dataForm = {
          merchant_id: this.merchantId,
          branch_code: this.branchCode,
          transaction_id: order.transaction_id,
        };

        SettingStoreService.orderDetail(dataForm).then(
          async (response) => {
            if (response.data.result.isSuccess) {
              $("#order-" + order.transaction_id + " i.show-order-info").html(
                "remove"
              );
              $("#order-" + order.transaction_id).after(response.data.data);
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error.response.data.result.message;
            this.hideLoader();
            this.setTimeOutNotification();
          }
        );
      }
    },

    stopOrdering() {
      if (!this.branchSelect.stop_ordering) {
        if (!confirm("Confirm to stop the ordering for today?")) {
          return;
        }
      }

      if (this.branchCode) {
        this.showLoader();
        var dataForm = {
          merchant_id: this.merchantId,
          branch_code: this.branchCode,
        };

        SettingStoreService.stopOrdering(dataForm).then(
          (response) => {
            if (response.data.result.isSuccess) {
              if (this.branchSelect.stop_ordering) {
                this.branchSelect.stop_ordering = 0;
              } else {
                this.branchSelect.stop_ordering = 1;
              }

              this.snackbar = "success";
              this.message = "Change success";
              this.setTimeOutNotification();
            } else {
              this.snackbar = "danger";
              this.message = response.data.result.message;
              this.setTimeOutNotification();
            }
            this.hideLoader();
          },
          (error) => {
            this.snackbar = "danger";
            this.message = error.response.data.result.message;
            this.setTimeOutNotification();
            this.hideLoader();
          }
        );
      }
    },

    showLoader() {
      this.loaderActive = true;
    },

    hideLoader() {
      this.loaderActive = false;
    },

    setTimeOutNotification() {
      setTimeout(() => {
        this.snackbar = null;
      }, 3000);
    },
  },
};
</script>
<style scoped>
table thead th:not(:first-child) {
  min-width: auto;
}

table th,
table td {
  padding: 0.35rem 0.4rem !important;
}

.page-header .container {
  color: #222 !important;
}

.nav-first {
  position: relative;
}
.nav-link {
  font-weight: bold;
}

.nav-first .count-order {
  position: absolute;
  top: 5px;
  right: 5px;
  border: 1px solid red;
  background: red;
  color: #ffffff;
  border-radius: 5px;
  padding: 0px 7px;
}

.multiselect {
  margin: 0 !important;
  max-width: 400px !important;
}

#general-tab .nav-item {
  width: 25%;
  text-align: center;
}

input[type="search"] {
  border: none;
  background: transparent;
  margin: 0;
  padding: 7px 8px;
  font-size: 14px;
  color: inherit;
  border: 1px solid transparent;
  border-radius: inherit;
  width: 100%;
  max-width: 500px;
}

input[type="search"]::placeholder {
  color: #bbb;
  text-align: left;
  font-weight: normal;
}

input[type="search"]:focus {
  border-color: #72959d;
  outline: none;
  border: none;
  border-bottom: 2px solid #72959d;
}

.nosubmit-parent {
  border: none;
  padding: 0;
}

input.nosubmit {
  border-bottom: 1px solid #d2d2d2;
  width: 100%;
  padding: 9px 4px 9px 40px;
  background: transparent
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' class='bi bi-search' viewBox='0 0 16 16'%3E%3Cpath d='M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z'%3E%3C/path%3E%3C/svg%3E")
    no-repeat 13px center;
}

.cl-22 {
  color: #222 !important;
}

.show-order-info {
  font-size: 28px !important;
  font-weight: bold;
  color: #007bff;
  cursor: pointer;
}
.btn-confirm-order {
  min-width: 50px !important;
  padding: 5px 10px !important;
  color: #28a745 !important;
  border-color: #28a745 !important;
}

.btn-accept-order,
.btn-reject-order {
  min-width: 80px !important;
  padding: 5px 10px !important;
}

.btn-accept-order {
  background: #28a745 !important;
  color: #ffffff !important;
  border-color: #28a745 !important;
}

.btn-accept-order:hover {
  background: #218838 !important;
  border-color: #218838 !important;
}

.btn-reject-order {
  background: #ffffff !important;
  color: #dc3545 !important;
  border-color: #dc3545 !important;
}

.btn-reject-order:hover {
  background: #dc3545 !important;
  color: #ffffff !important;
}

.btn-print-order {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 12px;
  border: 1px solid #6c757d;
  background: #ffffff;
  color: #495057;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
}

.btn-print-order:hover {
  background: #6c757d;
  color: #ffffff;
}

.btn-print-order .material-icons {
  font-size: 14px;
}

.btn-audio-off {
  background: #ffffff !important;
  color: #495057 !important;
  border: 1px solid #adb5bd !important;
}

.audio-icon {
  font-size: 16px !important;
}

.details-cell {
  min-width: 220px;
  white-space: normal;
}

.refund-ok {
  color: #28a745 !important;
}

.refund-bad {
  color: #dc3545 !important;
}

.manual-flow-notes {
  font-size: 12px;
  color: #6c757d;
}

.delivery-option {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  padding: 24px 12px;
  border: 2px solid #dee2e6;
  border-radius: 10px;
  background: #ffffff;
  color: #222;
  cursor: pointer;
  transition: all 0.15s ease;
}

.delivery-option:hover,
.delivery-option:focus {
  border-color: #28a745;
  background: #f3fbf5;
  outline: none;
}

.btn-cancel-accept {
  min-width: 80px !important;
  padding: 5px 10px !important;
  background: #ffffff !important;
  color: #6c757d !important;
  border-color: #6c757d !important;
}
.delivery-option.selected {
  border-color: #28a745;
  background: #f3fbf5;
  box-shadow: 0 0 0 1px #28a745;
}
.delivery-option .material-icons-round {
  font-size: 44px;
  color: #28a745;
}
.delivery-option .delivery-option-check {
  position: absolute;
  top: 8px;
  right: 8px;
  font-size: 22px;
}

.delivery-option-title {
  font-size: 16px;
  font-weight: bold;
}

.delivery-option-sub {
  font-size: 12px;
  color: #6c757d;
}

.delivery-option-price {
  font-size: 15px;
  font-weight: bold;
  color: #28a745;
}

.delivery-option-price small {
  font-size: 11px;
  font-weight: normal;
  color: #6c757d;
}

.delivery-option-price.is-muted {
  font-size: 12px;
  font-weight: normal;
  color: #6c757d;
}

.btn-confirm-order:hover {
  background: #28a745 !important;
  color: #ffffff !important;
}

.btn-refund-action {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 12px;
  border: 1px solid #4f46e5;
  background: #ffffff;
  color: #4f46e5;
  border-radius: 6px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease;
  white-space: nowrap;
}

.btn-refund-action:hover {
  background: #4f46e5;
  color: #ffffff;
}

.btn-refund-action .material-icons {
  font-size: 14px;
}

tbody:not(.no-data) > tr:nth-child(2n + 1) {
  background: #f0f2f5;
}

tbody:not(.no-data) > tr:hover {
  background: #ebecee;
}

@media (max-width: 500px) {
  .waiting-time {
    display: block !important;
    text-align: right;
  }

  .waiting-time button {
    margin-top: 15px;
  }

  #general-tab .nav-item {
    width: calc(100% / 3) !important;
  }
}
</style>
